import { render, staticRenderFns } from "./PointNetridecashTechcoinError.vue?vue&type=template&id=2f505f6f"
import script from "./PointNetridecashTechcoinError.vue?vue&type=script&lang=js"
export * from "./PointNetridecashTechcoinError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports